import React from 'react';

export default function Footer() {
  return (
    <footer className="footer" aria-label="Footer">
      <div className="footer-inner">
        <img src="/logo-footer.png" alt="Pramaan Digital Signatures" className="footer-logo" />
        <a href="mailto:contact@oldmonktech.com" className="footer-email">
          contact@oldmonktech.com
        </a>
        <span className="footer-india">
          <span className="footer-india-dot" aria-hidden="true" />
          Built in India
        </span>
      </div>
    </footer>
  );
}
